import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/common_action/fillList_action";
import {
  role_detail_action,
  role_insertUpdate_action,
} from "../../../actions/adminModule_action/roles_action";
import {
  responseError,
  toastError,
  toastSuccess,
} from "../../../utils/constants";
import moment from "moment";
import Header from "../../../common_components/Header";
import { Modal } from "react-bootstrap";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";

class RoleAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showModal: false,
      moduleNameList: [],
      moduleAccessList: [],
      reportAccessList: [],
      Name: "",
      Description: "",
      is_active: true,
      role_id: 0,
      isSystemExpanded: false,
      CreatedBy: "",
      CreatedDate: "",
      ModifiedBy: "",
      ModifiedDate: "",
      DeletedBy: "",
      DeletedDate: "",
      mpModalData: {},
    };
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);
    this.setState(
      {
        role_id:
          this.props.location.state.role_id != 0
            ? this.props.location.state.role_id
            : 0,
      },
      () => this.RoleDetails()
    );
  }
  navigateBackRole() {
    this.props.navigate("/role");
  }
  clearFields() {
    this.setState({
      role_id: "",
      Name: "",
      Description: "",
      is_activeID: 0,
    });
  }
  RoleDetails() {
    const { role_id } = this.state;
    this.setState({ isLoading: true });

    this.props
      .role_detail_action(role_id)
      .then((data) => {
        if (data.error !== 1) {
          const [roleDataArray, moduleAccessData, reportAccessData] = data.data;

          if (roleDataArray && roleDataArray.length > 0) {
            const roleData = roleDataArray[0];
            const moduleNameList = moduleAccessData
              .map(data => data.ModuleName)
              .filter((value, index, self) => self.indexOf(value) === index)
              .map(name => ({ ModuleName: name }));

            this.setState({
              isLoading: false,
              role_id: roleData.role_id,
              Name: roleData.name,
              Description: roleData.description,
              moduleNameList: moduleNameList,
              moduleAccessList: moduleAccessData,
              // moduleAccessList: this.transformModuleAccessData(moduleAccessData),
              reportAccessList: reportAccessData,
              CreatedBy: roleData.CreatedBy || 'Not Available',
              CreatedDate: roleData.CreatedDate || '',
              ModifiedBy: roleData.ModifiedBy || 'Not Available',
              ModifiedDate: roleData.ModifiedDate || '',
              DeletedBy: roleData.DeletedBy || 'Not Available',
              DeletedDate: roleData.DeletedDate || '',
            });
          } else {
            this.setState({ isLoading: false });
            responseError({ message: 'No role data found.' });
          }
        } else {
          this.setState({ isLoading: false });
          responseError(data);
        }
      })
      .catch((e) => {
        console.error(e);
        this.setState({ isLoading: false });
      });
  }
  handleModuleCheckboxChange = (e, index, accessType) => {
    const { moduleAccessList } = this.state;
    const updatedList = [...moduleAccessList];
    const isChecked = e.target.checked;

    // Update the specific access type
    updatedList[index][accessType] = isChecked;

    // If FullAccess is checked/unchecked, update all related permissions accordingly
    if (accessType === "FullAccess") {
      updatedList[index] = {
        ...updatedList[index],
        ReadAccess: isChecked,
        WriteAccess: isChecked,
        UpdateAccess: isChecked,
        DeleteAccess: isChecked,
      };
    }

    // Update the state with the new list
    this.setState({ moduleAccessList: updatedList });
  };
  handleReportCheckboxChange = (e, index, accessType) => {
    const { reportAccessList } = this.state;
    const updatedList = [...reportAccessList];
    const isChecked = e.target.checked;

    updatedList[index][accessType] = isChecked;

    if (accessType === "FullAccess") {
      updatedList[index] = {
        ...updatedList[index],
        ViewAccess: isChecked,
        DownloadAccess: isChecked,
      };
    }

    this.setState({ reportAccessList: updatedList });
  };


  async handleSubmit() {
    const {
      user_id,
      role_id,
      Name,
      Description,
      moduleAccessList,
      reportAccessList,
    } = this.state;

    // Validation checks
    if (Name === "") {
      toastError("Kindly Enter Name");
      return;
    }
    if (Description === "") {
      toastError("Kindly Enter Description");
      return;
    }
    if (
      !moduleAccessList.some(
        (module) =>
          module.FullAccess ||
          module.WriteAccess ||
          module.ReadAccess ||
          module.UpdateAccess ||
          module.DeleteAccess
      )
    ) {
      toastError("Please select at least one access option in Module Access");
      return;
    }

    this.setState({ isLoading: true });

    const modulArray = [];

    // Collecting module access based on permissions
    moduleAccessList.forEach((item) => {
      if (item.WriteAccess) {
        modulArray.push({ role_id: role_id, module_report_access_id: item.module_report_access_ids.find(id => id.access_name === 'Add') });
      }
      if (item.ReadAccess) {
        modulArray.push({ role_id: role_id, module_report_access_id: item.module_report_access_ids.find(id => id.access_name === 'View') });
      }
      if (item.UpdateAccess) {
        modulArray.push({ role_id: role_id, module_report_access_id: item.module_report_access_ids.find(id => id.access_name === 'Update') });
      }
      if (item.DeleteAccess) {
        modulArray.push({ role_id: role_id, module_report_access_id: item.module_report_access_ids.find(id => id.access_name === 'Delete') });
      }
    });

    const finalModulArray = modulArray.filter(item => item.module_report_access_id !== undefined && item.module_report_access_id !== null);
    const reportArray = reportAccessList
      .filter(
        (report) =>
          report.FullAccess || report.ViewAccess || report.DownloadAccess
      )
      .map((data) => ({
        role_id,
        module_report_access_id: data.module_report_access_id,
      }));

    const payload = {
      user_id,
      role_id,
      Name,
      Description,
      moduleAccessList: finalModulArray,
      reportAccessList: reportArray,
    };

    this.props
      .role_insertUpdate_action(payload)
      .then((data) => {
        if (data && data.error === 0) {
          this.setState({ isLoading: false }, () => {
            toastSuccess(
              role_id
                ? "Data Updated Successfully"
                : "Data Inserted Successfully"
            );
          });
          setTimeout(() => {
            this.props.navigate("/role");
          }, 1500);
        } else {
          responseError(data);
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isLoading: false });
        toastError("An unexpected error occurred.", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  }

  openSpecialModal(data) {
    this.setState({ showModal: true, mpModalData: data });
  }
  closeSpecialModal() {
    this.setState({ showModal: false, mpModalData: [] });
  }

  render() {
    const {
      isLoading,
      showModal, moduleNameList,
      moduleAccessList,
      reportAccessList,
      Name,
      Description,
      is_active,
      role_id,
      isSystemExpanded,
      CreatedBy,
      CreatedDate,
      ModifiedBy,
      ModifiedDate,
      DeletedBy,
      DeletedDate,
      mpModalData,
    } = this.state;

    return (
      <>
        {isLoading ? <Loader /> : null}
        <main id="main">

          <div className="website-view">
            <Header data={[8]} />
          </div>
          <div className="mobile-view">
            <MobileHeader data={[8]} />
          </div>
          <section class='header_margin_top'>
            <div className="container-fluid">
              <div className="page-header">
                <h2 class="mb-3 dashboard-tit  py-0 blog-name">{role_id ? "Edit" : "Add"} Role</h2>
                <div className="Service_display pt-2">
                  <h6 className="Services_Active_or_Not">
                    {role_id !== 0
                      ? is_active === 1
                        ? "Active"
                        : "Inactive"
                      : "Active"}
                  </h6>
                  <div className="checkbox checbox-switch">
                    <label className="switch">
                      {role_id ? (
                        <>
                          <input
                            type="checkbox"
                            checked={is_active === 1}
                            onChange={() => {
                              this.setState((prevState) => ({
                                is_active: prevState.is_active === 1 ? 0 : 1,
                              }));
                            }}
                          />
                          <span className="slider round"></span>
                        </>
                      ) : (
                        <>
                          <input type="checkbox" checked={true} readOnly />
                          <span className="slider round"></span>
                        </>
                      )}
                    </label>
                  </div>
                </div>
              </div>
              <div className="card Service_fields border-0">
                <div className="card-body p-0">
                  {/* Role Information Section */}
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label htmlFor="roleName">Role Name <span className="mendatory_class">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          disabled={role_id !== 0}
                          id="roleName"
                          name="name"
                          value={Name}
                          onChange={(e) => this.setState({ Name: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="col-md-10">
                      <div className="form-group">
                        <label htmlFor="roleDescription">Role Description <span className="mendatory_class">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          id="roleDescription"
                          name="description"
                          value={Description}
                          onChange={(e) => this.setState({ Description: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Module Access Section */}
                  <div className="row">
                    <div className="col-md-7">

                      <p className="mb-2">Module Access</p>

                      <div className="custom_table">
                        <div className="hack1">
                          <div className="hack2">
                            <table className="table table-bordered table-striped">
                              <thead>
                                <tr className="text-center">
                                  <th className="text-left">Module Name</th>
                                  <th>Full Access</th>
                                  <th>Read</th>
                                  <th>Write</th>
                                  <th>Update</th>
                                  <th>Delete</th>
                                  <th>More Permissions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {moduleNameList && moduleNameList.length > 0 ? (
                                  moduleNameList.map((module, index) => {
                                    // Find all access data for the current module
                                    const accessData = moduleAccessList.filter(access => access.ModuleName === module.ModuleName);

                                    // Initialize access properties
                                    const accessMap = {
                                      FullAccess: false,
                                      ReadAccess: false,
                                      WriteAccess: false,
                                      UpdateAccess: false,
                                      DeleteAccess: false,
                                      MorePermissions: false,
                                      module_report_access_ids: [],
                                    };

                                    // Populate access properties based on accessData
                                    accessData.forEach(access => {
                                      if (access.IsSelect) {
                                        accessMap.ReadAccess = true;
                                        if (access.access_name === 'Add') {
                                          accessMap.WriteAccess = true;
                                        }
                                        if (access.access_name === 'Update') {
                                          accessMap.UpdateAccess = true;
                                        }
                                        if (access.access_name === 'Delete') {
                                          accessMap.DeleteAccess = true;
                                        }
                                        if (access.is_morepermission) {
                                          accessMap.MorePermissions = true; // Show More Permissions if true
                                        }
                                        accessMap.module_report_access_ids.push(access.module_report_access_id);
                                      }
                                    });

                                    return (
                                      <tr key={`module-${index}`}>
                                        <td className="text-left">{module.ModuleName}</td>
                                        <td>
                                          <div className="bg">
                                            <div className="chiller_cb align-self-center">
                                              <input
                                                id={`moduleCheckFullAccess${index}`}
                                                type="checkbox"
                                                checked={accessMap.FullAccess}
                                                onChange={(e) => this.handleModuleCheckboxChange(e, index, 'FullAccess')}
                                              />
                                              <label htmlFor={`moduleCheckFullAccess${index}`}>&nbsp;</label>
                                              <span />
                                            </div>
                                          </div>
                                        </td>
                                        {["ReadAccess", "WriteAccess", "UpdateAccess", "DeleteAccess"].map((accessType, accessIndex) => (
                                          <td key={`access-${accessIndex}`}>
                                            <div className="bg">
                                              <div className="chiller_cb align-self-center">
                                                <input
                                                  id={`moduleCheck${accessType}${index}`}
                                                  type="checkbox"
                                                  checked={accessMap[accessType]}
                                                  onChange={(e) => this.handleModuleCheckboxChange(e, index, accessType)}
                                                />
                                                <label htmlFor={`moduleCheck${accessType}${index}`}>&nbsp;</label>
                                                <span />
                                              </div>
                                            </div>
                                          </td>
                                        ))}
                                        {/* Check for More Permissions */}
                                        <td className="text-center" style={{ color: "blue", cursor: "pointer" }}>
                                          {accessMap.MorePermissions && (
                                            <span onClick={() => this.openSpecialModal(module)}>More Permissions</span>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan={7} className="text-center">No Records Available</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Report Access Section */}
                    <div className="col-md-5">
                      <p className="mb-2">Report Access</p>
                      <div className="custom_table">
                        <div className="hack1">
                          <div className="hack2">
                            <table className="table table-bordered table-striped">
                              <thead>
                                <tr className="text-center">
                                  <th>Group</th>
                                  <th>Report Name</th>
                                  <th>Full Access</th>
                                  <th>View</th>
                                  <th>Download</th>
                                </tr>
                              </thead>
                              <tbody>
                                {reportAccessList && reportAccessList.length > 0 ? (
                                  reportAccessList.map((data, index) => (
                                    <tr key={`report-${index}`}>
                                      <td className="text-center">{data.GroupName}</td>
                                      <td className="text-center">{data.ReportName}</td>
                                      {["FullAccess", "ViewAccess", "DownloadAccess"].map((accessType, accessIndex) => (
                                        <td key={`reportAccess-${accessIndex}`}>
                                          <div className="bg">
                                            <div className="chiller_cb align-self-center">
                                              <input
                                                id={`reportCheck${accessType}${index}`}
                                                type="checkbox"
                                                checked={data[accessType]}
                                                onChange={(e) => this.handleReportCheckboxChange(e, index, accessType)}
                                              />
                                              <label htmlFor={`reportCheck${accessType}${index}`}>&nbsp;</label>
                                              <span />
                                            </div>
                                          </div>
                                        </td>
                                      ))}
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">No Records Available</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="p-2  mb-3">
                      <button class="btn btn-outline-primary px-3 mr-2" onClick={() => this.handleSubmit()}>{role_id ? "Update" : "Save"}</button>
                      <button class="btn btn-outline-secondary  px-3" onClick={() => this.navigateBackRole()}>Back</button>
                    </div>
                  </div>
                  {role_id ? (<div className="system_info" aria-expanded={isSystemExpanded}
                    onClick={() => this.setState({ isSystemExpanded: !isSystemExpanded, })}>
                    <div className="row row_margin collpase_arrow_cursor">
                      <div className="col-md-6 col-sm-6 col-7">
                        <span data-toggle="collapse" data-target="#Sys_info" className="">
                          <i className={isSystemExpanded ? "fa fa-chevron-down CRM_rotate_data"
                            : "fa fa-chevron-right CRM_rotate_data"} style={{ fontSize: 12, color: "#898989" }} />
                          <span className="heading_text" style={{ paddingLeft: 5 }}>System Info</span>
                        </span></div>
                    </div>
                    <hr style={{ marginTop: 0, marginBottom: 15, border: "1px solid #c0c0c0" }} />
                    <div id="collapseOne" className={`panel-collapse collapse p-2 pt-0 ${isSystemExpanded ? "show" : ""}`} aria-labelledby="headingOne">
                      <div className="form-group"><div className="row"><div className="col-md-4">
                        <div className="form-group"><label className="sys_info_label" htmlFor="email">
                          Created By</label>
                          <p className="Sys_info_style">{CreatedDate != null ? CreatedBy : "Not Available"}</p>
                        </div>
                        <div className="form-group">
                          <label className="sys_info_label" htmlFor="email">Created Date</label>
                          <p className="Sys_info_style">{CreatedDate != "" ? moment(CreatedDate).format("DD-MM-YYYY") : ""}</p>
                        </div>
                      </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="sys_info_label" htmlFor="email">Modified By</label>
                            <p className="Sys_info_style">{ModifiedDate != null ? ModifiedBy : "Not Available"}</p>
                          </div>
                          <div className="form-group">
                            <label className="sys_info_label" htmlFor="email" >Modified Date</label>
                            <p className="Sys_info_style">{ModifiedDate != null ? moment(ModifiedDate).format("DD-MM-YYYY") : "Not Available"}</p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="sys_info_label" htmlFor="email">Deleted By</label>
                            <p className="Sys_info_style">{DeletedDate != null ? DeletedBy : "Not Available"}</p>
                          </div>
                          <div className="form-group">
                            <label className="sys_info_label" htmlFor="email" >Deleted Date</label>
                            <p className="Sys_info_style">{DeletedDate != null ? moment(DeletedDate).format("DD-MM-YYYY") : "Not Available"}</p>
                          </div>
                        </div></div>
                      </div></div>
                  </div>) : null}
                </div>
              </div>
            </div>
            <Modal
              show={showModal}
              size="lg"
              onHide={() => this.closeSpecialModal()}
            >
              <Modal.Header>
                <div className="container-fluid">
                  <div className="page-header">
                    <h4
                      className="page-title"
                      style={{ fontSize: "20px", marginBottom: "-10px" }}
                    >
                      More Permissions : {mpModalData?.ModuleName}
                    </h4>
                    <div className="Service_display">
                      <h1
                        className="Services_Active_or_Not"
                        style={{
                          fontSize: "20px",
                          marginBottom: "-10px",
                          fontWeight: "800",
                          cursor: "pointer",
                        }}
                        onClick={() => this.closeSpecialModal()}
                      >
                        X
                      </h1>
                    </div>
                  </div>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="container-fluid">
                  <div className="custom_table">
                    <div className="hack1">
                      <div className="hack2">
                        <table
                          className="table table-bordered table-striped"
                          id="dashboard-table"
                        >
                          <thead>
                            <tr className="text-center">
                              <th>Permission Name</th>
                              <th>Access</th>
                            </tr>
                          </thead>
                          <tbody id="myTable">
                            {mpModalData &&
                              Object.keys(mpModalData).length > 0 ? (
                              Object.entries(mpModalData)
                                .filter(
                                  ([key, value]) =>
                                    typeof value === "object" &&
                                    value.is_morepermission === true
                                )
                                .map(([key, value], i) => (
                                  <tr key={`${mpModalData.ModuleName}-${key}`}>
                                    <td className="text-center">{key}</td>
                                    <td>
                                      <div className="bg">
                                        <div className="chiller_cb align-self-center">
                                          <input
                                            id={`MorePermissionCheck${mpModalData.ModuleName}${i}`}
                                            type="checkbox"
                                            checked={value.IsSelect === 1}
                                            onChange={(e) => {
                                              this.handleMorePermissionChange(
                                                key,
                                                e.target.checked
                                              );
                                            }}
                                          />
                                          <label
                                            htmlFor={`MorePermissionCheck${mpModalData.ModuleName}${i}`}
                                          >
                                            &nbsp;
                                          </label>
                                          <span />
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan={2} className="text-center">
                                  No Permissions Available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>

                <button class="btn btn-outline-primary btn-sm" onClick={() => this.saveMorePermissions()}>Save</button>

                <button class="btn btn-outline-secondary btn-sm" onClick={() => this.closeSpecialModal()}>Close</button>

              </Modal.Footer>
            </Modal>
          </section>
        </main>
        <Footer />
        <ToastContainer />
      </>
    );
  }
}
export default withRouter(
  connect(null, { fill_action, role_insertUpdate_action, role_detail_action })(
    RoleAU
  )
);
